<template>
  <Teleport to="body">
    <div
      class="fixed inset-0 z-[2200] flex items-center justify-center bg-darkest/70 mobOnly:bg-lightest desk:p-16"
      @click.self="$emit('close')"
    >
      <div class="bg-lightest w-full h-full desk:h-auto desk:max-w-[900px] desk:max-h-[90vh] desk:shadow-xl relative flex flex-col">
        <!-- Header with close button -->
        <div class="flex items-center justify-between p-16 desk:border-b desk:border-light shrink-0">
          <span class="type-sm-medium">
            {{ $t('mypage.sampleInventory.infoBanner.guideLink') }}
          </span>
          <button
            class="p-4 text-dark hover:text-darkest transition-colors"
            :aria-label="$t('general.close')"
            @click="$emit('close')"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Scrollable image container -->
        <div class="overflow-y-auto flex-1">
          <img
            :src="imageUrl"
            :alt="$t('mypage.sampleInventory.infoBanner.guideLink')"
            class="w-full h-auto"
          >
        </div>

        <!-- Sticky close button (mobile only) -->
        <div class="desk:hidden sticky bottom-0 p-16 bg-lightest border-t border-light">
          <button
            class="btn btn--primary w-full"
            @click="$emit('close')"
          >
            {{ $t('general.close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
defineProps<{
  imageUrl: string;
}>();

defineEmits<{
  (e: 'close'): void;
}>();
</script>
